jQuery.fn.InitializePage = function (option) {
    var defaults = {
        initialJsonData: null
    };
    var option = $.extend({}, defaults, option);

    //load json data
    var viewModelJs = JSON.parse(option.initialJsonData);
    var viewModel = ko.mapping.fromJS(viewModelJs)

    var pageContent = $(this);

    //// ViewModel to Send
    viewModel.FullName = ko.observable();
    viewModel.ConfirmEmail = ko.observable();
    viewModel.Email = ko.observable();
    viewModel.Message = ko.observable();
    viewModel.RecaptchaResponse = ko.observable();
    viewModel.hasSubmitted = ko.observable(false);
    //// Components to handle validated of Email Form
    viewModel.FullNameValid = ko.observable(true);
    viewModel.EmailValid = ko.observable(true);
    viewModel.ConfirmEmailValid = ko.observable(true);
    viewModel.RecaptchaValid = ko.observable(true);
    viewModel.ErrorResponse = ko.observable();
    viewModel.ValidForm = ko.computed(function () {
        return (viewModel.FullNameValid() && viewModel.EmailValid() && viewModel.ConfirmEmailValid() && viewModel.RecaptchaValid());
    });

    viewModel.GetRequestObject = function () {
        var reqObj = {
            FullName: viewModel.FullName(),
            ConfirmEmail: viewModel.ConfirmEmail(),
            Email: viewModel.Email(),
            Message: viewModel.Message(),
            RecaptchaResponse: viewModel.RecaptchaResponse()
        }

        return reqObj;
    };

    viewModel.isSubscriptionFormValidated = function () {
        if (viewModel.FullName() === "" || viewModel.FullName() == "undefined" || viewModel.FullName() === undefined) {
            viewModel.FullNameValid(false);
        } else {
            viewModel.FullNameValid(true);
        }

        if ((viewModel.Email() === "" || viewModel.Email() == "undefined" || viewModel.Email() === undefined)) {
            viewModel.EmailValid(false);
        } else {
            viewModel.EmailValid(true);
        }

        if (viewModel.ConfirmEmail() === "" || viewModel.ConfirmEmail() == "undefined" || viewModel.ConfirmEmail() === undefined || viewModel.Email() !== viewModel.ConfirmEmail()) {
            viewModel.ConfirmEmailValid(false);
        } else {
            viewModel.ConfirmEmailValid(true);
        }

        if (viewModel.RecaptchaResponse() === "" || viewModel.RecaptchaResponse() == "undefined" || viewModel.RecaptchaResponse() === undefined) {
            viewModel.RecaptchaValid(false);
        } else {
            viewModel.RecaptchaValid(true);
        }

        return (viewModel.FullNameValid() && viewModel.EmailValid() && viewModel.ConfirmEmailValid() && viewModel.RecaptchaValid());
    };

    viewModel.ClearFormFields = function () {
        $(".subscribe-form-input").val("");
        viewModel.hasSubmitted(false);
    };

    //// Generate Email
    viewModel.GenerateSubscriptionEmail = function () {
        var recaptchaToken = document.getElementById("reCAPTCHATOKEN") != null ? document.getElementById("reCAPTCHATOKEN").value : "";

        if (recaptchaToken === "") {
           grecaptcha.enterprise.execute();
           return;
        }

        viewModel.RecaptchaResponse(recaptchaToken);
        
        if (viewModel.isSubscriptionFormValidated()) {
            var viewModelToSend = viewModel.GetRequestObject();
            $.ajax({
                url: "/api/sitecore/general/ContactUsSubmission",
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.mapping.toJSON(viewModelToSend),
                cache: false,
                success: function (data) {
                    if (data === true) {
                        viewModel.hasSubmitted(true);
                    } else {
                        viewModel.ErrorResponse(data);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    console.log(xhr);
                    console.log("textStatus : " + textStatus);
                    console.log("errorThrown : " + errorThrown);
                }
            });
        } else {
            var offset = $('.subscribe-landing').offset().top;

            $("html, body").animate({
                scrollTop: offset
            });

            return false;
        }
    };

    //// Apply Bindings
    ko.applyBindings(viewModel, pageContent.get(0));
};
